import TableError from "./error"

function TableNoDataError({ columnName, mode, newMode, message }) {
  TableError.call(this, message)
  this.name = "TableNoDataError"
  this.columnName = columnName
  this.mode = mode
  this.newMode = newMode
}

TableNoDataError.prototype = Object.create(TableError.prototype)
TableNoDataError.prototype.constructor = TableNoDataError

export default TableNoDataError
